import { IoWarningOutline } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../Providers/AuthProvider";

const LoginAndPrepareOffer = ({ custId, offerNo, offerSiteId }) => {
    const navigate = useNavigate()
    const { authState, logout } = useAuth()

    const handleChangAccount = () => {
        logout(false)
        navigate('/login', {
            state: {
                redirectParams: { custId, offerNo, offerSiteId }
            },
            replace: true
        })
    }

    if (!authState.user) {
        return (
            <div className="container main-container-holder">
                <div className="row">
                    <div className='d-flex flex-column align-items-center justify-content-center' style={{ fontSize: '25px' }}>
                        <IoWarningOutline size={150} className='warning-text-color ' />
                        <span className='mt-5'>Aby zrealizować zamówienie, musisz być zalogowany na kontrahenta, </span>
                        <span>na którego została przygotowana oferta.</span>
                        <div className="d-flex mt-5">
                            <button className='btn-app-primary me-5' onClick={() => navigate('/login', {
                                state: {
                                    redirectParams: { custId, offerNo, offerSiteId }
                                },
                                replace: true
                            })}>Zaloguj się</button>
                            <button className='btn-app-secondary' onClick={() => navigate('/', { replace: true })}>Powrót na stronę główną</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    else {
        return (
            <div className="container main-container-holder">
                <div className="row">
                    <div className='d-flex flex-column align-items-center justify-content-center' style={{ fontSize: '25px' }}>
                        <IoWarningOutline size={150} className='warning-text-color ' />
                        <span className='mt-5'>Oferta jest przeznaczona dla innego kontrahenta niż obecnie zalogowany. </span>
                        <span>Zaloguj się na kontrahenta, dla którego przygotowano ofertę</span>
                        <div className="d-flex mt-5">
                            <button className='btn-app-primary me-5' onClick={handleChangAccount}>Zmień konto</button>
                            <button className='btn-app-secondary' onClick={() => navigate('/')}>Powrót na stronę główną</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LoginAndPrepareOffer